export default __webpack_public_path__ + "static/screenFourthSectionRu-857b5c0d340d98433f7537ffc491f378.webp";